import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Box } from '@mui/material'
import { BaseButtons, BaseGridLayout, ICONE } from '@lucan/base-ui'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import ValutaServizioRender from 'components/valutaServizio/ValutaServizioRender'
import BreadcrumbsDatiConducente from 'components/ui/datiConducente/BreadcrumbsDatiConducente'
import { DATICONDUCENTE_VERBALE_COMPLETAMENTO } from 'configuration/datiConducente'
import ConfigManager from 'components/config/ConfigManager'
import Sezione from 'components/ui/Sezione'
import Titolone from 'components/ui/Titolone'
import Testo from 'components/ui/Testo'
import Titoletto from 'components/ui/Titoletto'
import MessaggioEvidenziato from 'components/ui/MessaggioEvidenziato'
import { useDatiConducenteContext } from 'context/DatiConducenteProvider'
import useNavigate from 'utils/useNavigate'
import useStepApi from 'pages/Frontoffice/useStep'
import useLogout from 'hook/useLogout'
import useSchermoStretto from 'hook/useSchermoStretto'
import DatiConducenteContenitore from '../DatiConducenteContenitore'
import { MODALITA_INVIO_DATI_CONDUCENTE, SERVIZIO_DATI_CONDUCENTE } from '../utilDatiConducente'
import { ModalitaConsegnaNonOnline } from './DecurtazionePuntiConsegnaModulo'
import { STEPS } from './useStepDatiConducente'
import Verbale from './Verbale'

const CFG = DATICONDUCENTE_VERBALE_COMPLETAMENTO

export default function Completamento() {
  return (
    <>
      <ConfigManager
        elenchiConfig={[
          ELENCHI.CFG_DATICONDUCENTE_VERBALE_COMPLETAMENTO,
          ELENCHI.CFG_DATICONDUCENTE_VERBALE_DECURTAZIONE,
        ]}
        render={({ txt, val }) =>
          <DatiConducenteContenitore>
            <CompletamentoInterno txt={txt} val={val} />
          </DatiConducenteContenitore>
        }
      />
      <ValutaServizioRender />
    </>
  )
}



function CompletamentoInterno(props) {
  const { txt, val } = props

  const { modalitaInvio } = useParams()

  const {
    verbale,
    chiaveVerbaleCompletamento,
    salvaVerbale,
    setListaVerbali,
  } = useDatiConducenteContext()

  const { sendStep } = useStepApi(SERVIZIO_DATI_CONDUCENTE)

  useEffect(() => {
    sendStep(STEPS.DECURTAZIONE_PUNTI_COMPLETA, chiaveVerbaleCompletamento, {})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { navigate } = useNavigate()

  function tornaAlVerbale() {
    salvaVerbale(null)
    setListaVerbali(null)
    navigate(CHIAVI_ROUTES.DATI_CONDUCENTE_VERBALE, { tab: Verbale.CHIAVI_TABS.DATI_VERBALE })
  }

  const { BottoneLogout } = useLogout({
    testoBottone: val(CFG.ESCI_DAL_VERBALE)
  })

  const schermoStretto = useSchermoStretto()

  return (
    <>
      <BaseGridLayout justifySpaceBetween alignCenter>
        <BreadcrumbsDatiConducente conf={val(CFG.BREADCRUMBS, {}, true)} />
        {BottoneLogout}
      </BaseGridLayout>

      {modalitaInvio === MODALITA_INVIO_DATI_CONDUCENTE.CARICA_ONLINE ? (
        <BaseGridLayout alignCenter spacing={1} noWrap>
          <ICONE.OK />
          <Titolone>{txt(CFG.TITOLO_DATI_RICEVUTI)}</Titolone>
        </BaseGridLayout>
      ) : (
        <BaseGridLayout alignCenter spacing={1} noWrap>
          <ICONE.RUOTA_180_GRADI color='warning' />
          <Titolone>{txt(CFG.TITOLO_IN_ATTESA_DATI)}</Titolone>
        </BaseGridLayout>
      )}

      <Box sx={{ ...(!schermoStretto && { px: 5 }), py: 2 }}>
        <Titoletto>{txt(CFG.GRAZIE)}</Titoletto>

        {modalitaInvio === MODALITA_INVIO_DATI_CONDUCENTE.CARICA_ONLINE ? (
          <Testo>{txt(CFG.MODULO_RICEVUTO)} <b>{verbale.numero_verbale}</b>.</Testo>
        ) : (
          <BaseGridLayout vertical>
            <Testo>
              {txt(CFG.MODULO_COMPILATO)} <b>{verbale.numero_verbale}</b>.
              <br />
              {txt(CFG.ATTESA_RICEZIONE)}
            </Testo>

            <MessaggioEvidenziato error titolo={val(CFG.AVVISO_DATI_NON_TRASMESSI_TITOLO)}>
              {txt(CFG.AVVISO_DATI_NON_TRASMESSI_DESCR)}
            </MessaggioEvidenziato>

            <Sezione>
              <ModalitaConsegnaNonOnline
                txt={txt}
                modalita={modalitaInvio}
              />
            </Sezione>
          </BaseGridLayout>
        )}

        <BaseButtons.MenoDettagli
          testo={val(CFG.TORNA_AL_VERBALE)}
          onClick={tornaAlVerbale}
          sx={{ mt: 3 }}
        />
      </Box>
    </>
  )
}